// 由 EB view/admin/src/router/modules/maintain.js 自动转换
// +----------------------------------------------------------------------
// | EB [ EB赋能开发者，助力企业发展 ]
// +----------------------------------------------------------------------
// | Copyright (c) 2016-2026 https://www.eb.com All rights reserved.
// +----------------------------------------------------------------------
// | Licensed EB并不是自由软件，未经许可不能去掉EB相关版权
// +----------------------------------------------------------------------
// | Author: EB Team <admin@eb.com>
// +----------------------------------------------------------------------
import Layout from '@/layout/index.vue';
import type { RouteRecordRaw } from 'vue-router'
import { roterPre } from '@/setting';
const maintainRouter: RouteRecordRaw =
  {
    path: `${roterPre}/maintain`,
    name: 'maintain',
    meta: {
      title: '安全维护'
    },
    alwaysShow: true,
    component: Layout,
    children: [
      {
        path: 'dataBackup',
        name: 'DataBackup',
        meta: {
          title: '数据备份',
          noCache: true
        },
        component: () => import('@/views/maintain/dataBackup/index.vue')
      },
      {
        path: 'auth',
        name: 'MaintainAuth',
        meta: {
          title: '商业授权',
          noCache: true
        },
        component: () => import('@/views/maintain/auth/index.vue')
      },
      {
        path: 'cache',
        name: 'MaintainCache',
        meta: {
          title: '清除缓存',
          noCache: true
        },
        component: () => import('@/views/maintain/cache/index.vue')
      },
      {
        path: 'copyRight',
        name: 'MaintainCopyRight',
        meta: {
          title: '去版权',
          noCache: true
        },
        component: () => import('@/views/maintain/copyRight/index.vue')
      },
    ]
  }

export default maintainRouter;
